<script>

import NewArticle from "@/views/components/cms/new/NewArticle.vue";

export default {
  name: "UnternehmenspraesentationNew",
  components: {
    NewArticle,
  },
}
</script>

<template>
  <NewArticle :category-id="2"></NewArticle>
</template>

<style scoped>

</style>
